export default __webpack_public_path__ + "static/media/15.c828b9c2.jpg";